export default __webpack_public_path__ + "static/media/stories_gray.9674485b.svg";